import { Plugin } from "grapesjs";

const ImagePlugin: Plugin = async (editor, opts ={}) => {
   editor?.BlockManager.add('custom-svg-block', {
      label: 'SVG Shape',
      category: 'Image',
      media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 4H21A2 2 0 0 1 23 6V18A2 2 0 0 1 21 20H3A2 2 0 0 1 1 18V6A2 2 0 0 1 3 4Z"/></svg>',
      content: {
        type: 'svg',
        content: '<div class="svg-placeholder" style="position: absolute; top: 50px; left: 50px;">SVG will go here</div>',
        resizable: {
          tl: 1, // Top-left handle
          tc: 1, // Top-center handle
          tr: 1, // Top-right handle
          cl: 1, // Center-left handle
          cr: 1, // Center-right handle
          bl: 1, // Bottom-left handle
          bc: 1, // Bottom-center handle
          br: 1, // Bottom-right handle
          updateTarget: (el, rect, options) => {
            const { top, left, width, height } = rect;

            // Update position and size
            el.style.top = `${top}px`;
            el.style.left = `${left}px`;
            el.style.width = `${width}px`;
            el.style.height = `${height}px`;

            // Calculate scaling factor based on the new width
            const initialWidth = 200; // Default width
            const initialFontSize = 16; // Default font size
            const scaleFactor = width / initialWidth;

            // Update font size proportionally
            el.style.fontSize = `${initialFontSize * scaleFactor}px`;
          },
        },
      },

      attributes: { class: 'fa fa-code' },
    });

     editor?.BlockManager.add('custom-image', {
      label: 'Image',
      category: 'Image',
      media: "<svg viewBox=\"0 0 24 24\">\n        <path fill=\"currentColor\" d=\"M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z\" />\n      </svg>",
      content: {
        type: 'image',
        style: {
          position: 'absolute',
          top: '50px', // Default top position
          left: '50px', // Default left position
          width: '500px', // Default width
          height: 'auto', // Maintain aspect ratio
        },
        attributes: {
          src: 'https://via.placeholder.com/150', // Default placeholder image
        },
      },
      attributes: { class: 'fa fa-image' },
    });

    editor?.BlockManager.add('custom-text', {
    label: 'Text',
    category: 'Image',
    media: `
    <svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M3,4H21A2,2 0 0,1 23,6V18A2,2 0 0,1 21,20H3A2,2 0 0,1 1,18V6A2,2 0 0,1 3,4M12,7V17H14V7H12M10,7H8V17H10V7Z" />
    </svg>`,
    content: {
      type: 'text',
      style: {
      position: 'absolute',
      top: '50px', // Default top position
      left: '50px', // Default left position
      width: '200px', // Default width
      height: 'auto', // Maintain aspect ratio
      fontSize: '16px', // Initial font size
      },
      content: 'Insert your text here', // Default text content
      resizable: {
      tl: 1, // Top-left handle
      tc: 1, // Top-center handle
      tr: 1, // Top-right handle
      cl: 1, // Center-left handle
      cr: 1, // Center-right handle
      bl: 1, // Bottom-left handle
      bc: 1, // Bottom-center handle
      br: 1, // Bottom-right handle
      updateTarget: (el, rect, options) => {
        const { top, left, width, height } = rect;

        // Update position and size
        el.style.top = `${top}px`;
        el.style.left = `${left}px`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;

        // Calculate scaling factor based on the new width
        const initialWidth = 200; // Default width
        const initialFontSize = 16; // Default font size
        const scaleFactor = width / initialWidth;

        // Update font size proportionally
        el.style.fontSize = `${initialFontSize * scaleFactor}px`;
      },
      },
    },
    attributes: { class: 'fa fa-text' },
    });
}
export default ImagePlugin;